import { render, staticRenderFns } from "./TrialPromo.vue?vue&type=template&id=28243398&"
import script from "./TrialPromo.vue?vue&type=script&lang=js&"
export * from "./TrialPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports